const DEFAULT_APP_NAME = "Goalzin";
const DEFAULT_LOGO_PATH = "assets/logo/logo-new.png";

type BrandingConfig = {
  name?: string;
  logo?: string;
};

declare global {
  interface Window {
    __APP_BRANDING__?: BrandingConfig;
  }
}

const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

const normalizeRelativePath = (path: string) => path.replace(/^\/+/, "");

const getRuntimeBranding = (): BrandingConfig => {
  if (typeof window === "undefined") {
    return {};
  }
  return window.__APP_BRANDING__ || {};
};

const runtimeBranding = getRuntimeBranding();

const configuredName =
  runtimeBranding.name || process.env.REACT_APP_APPLICATION_NAME;

const configuredLogo =
  runtimeBranding.logo || process.env.REACT_APP_APPLICATION_LOGO;

const resolveLogoUrl = () => {
  const logoPath = configuredLogo || DEFAULT_LOGO_PATH;
  if (logoPath && /^https?:\/\//i.test(logoPath)) {
    return logoPath;
  }
  const relativePath = normalizeRelativePath(logoPath);
  return publicUrl ? `${publicUrl}/${relativePath}` : `/${relativePath}`;
};

export const APP_NAME = (configuredName || DEFAULT_APP_NAME).trim();

export const APP_LOGO = resolveLogoUrl();
